var map = {
	"./AETUA_logo.png": 128,
	"./address_image.svg": 129,
	"./animated_juan.png": 130,
	"./animated_logo.svg": 131,
	"./blogs_image.svg": 132,
	"./cloud_infrastructure.svg": 133,
	"./codeInLogo.png": 134,
	"./contactMail.png": 135,
	"./correlation_one_logo.png": 136,
	"./coursera_logo.png": 137,
	"./data_science.svg": 138,
	"./deeplearning_ai_logo.png": 139,
	"./delhivery_logo.png": 140,
	"./developerActivity.svg": 141,
	"./dsc_logo.png": 142,
	"./eafit_logo.png": 143,
	"./education.svg": 144,
	"./epam_logo.png": 145,
	"./experience.svg": 146,
	"./feelingProud.svg": 147,
	"./freecopy_logo.png": 148,
	"./fullstack.svg": 149,
	"./gcp_logo.png": 150,
	"./github_logo.png": 151,
	"./googleAssistant.jpg": 152,
	"./googleAssistant.svg": 153,
	"./google_logo.png": 154,
	"./ibm_logo.png": 155,
	"./iiitk_logo.png": 156,
	"./intel_logo.jpg": 157,
	"./iu_logo.png": 158,
	"./jsFramework.svg": 159,
	"./legato_logo.png": 160,
	"./manOnTable.svg": 161,
	"./microsoft_logo.png": 162,
	"./mozilla_logo.png": 163,
	"./muffito_logo.png": 164,
	"./nextuLogo.jpg": 165,
	"./nptel_logo.png": 166,
	"./oracle_logo.png": 167,
	"./portfolio.gif": 168,
	"./programmer.svg": 169,
	"./projects_image.svg": 170,
	"./pwa.png": 171,
	"./saayaHealthLogo.png": 172,
	"./sena_logo.png": 173,
	"./stanford_logo.png": 174,
	"./talksCardBack.svg": 175,
	"./talksCardBackAlt.svg": 176,
	"./tiktok_logo.png": 177,
	"./ui_ux_design.svg": 178,
	"./uniquindio_logo.png": 179,
	"./uniquindio_logo_big.png": 180,
	"./work-progress.png": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;